import React from 'react';
import { IoMdImages } from 'react-icons/io';

// Grilla simple (sin paginación): el álbum gratuito tiene un tope de 20
// fotos impuesto en la pantalla de carga de la modelo (PublicImages.jsx,
// MAX_PHOTOS), así que no hace falta infinite scroll ni un endpoint aparte.
function PublicPhotosGrid({ images = [], onPhotoClick }) {
  if (images.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center text-gray-400 dark:text-gray-500 py-16">
        <IoMdImages className="text-5xl mb-3" />
        <p>Todavía no hay fotos públicas.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3 w-full max-w-5xl">
      {images.map((url, index) => (
        <button
          key={url + index}
          onClick={() => onPhotoClick(index)}
          className="relative aspect-square overflow-hidden rounded-xl bg-gray-100 dark:bg-gray-800 group"
          aria-label={`Ver foto ${index + 1}`}
        >
          <img
            src={url}
            alt=""
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105"
          />
        </button>
      ))}
    </div>
  );
}

export default PublicPhotosGrid;
